import React, { useState } from 'react';
import { apiPut } from '@/api/client';
import { triggerErrorMessage, triggerSuccessMessage } from '@/components/ui/toast/notifications';

type Props = { enabled: boolean };

const NoteEncryptionPreference: React.FC<Props> = ({ enabled: initialEnabled }) => {
  const [enabled, setEnabled] = useState(initialEnabled);
  const [saving, setSaving] = useState(false);

  const update = async (next: boolean) => {
    setSaving(true);
    try {
      const response = await apiPut<{ value: boolean }>('/app/v1/user/settings', {
        key: 'notes_encrypt_by_default', value: next,
      });
      setEnabled(Boolean(response.value));
      triggerSuccessMessage('New note encryption preference saved. Existing notes were not changed.');
    } catch (error: any) {
      triggerErrorMessage(error?.message || 'Could not save the encryption preference.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-5">
      <h2 className="text-lg font-semibold mb-1">New note encryption</h2>
      <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
        Choose whether new notes start encrypted. This does not change existing notes. Attachments remain unencrypted by this setting.
      </p>
      <label className="flex items-center gap-3 text-sm">
        <input type="checkbox" checked={enabled} disabled={saving} onChange={(event) => void update(event.target.checked)} />
        Encrypt the body of new notes by default
      </label>
    </div>
  );
};

export default NoteEncryptionPreference;
